import '../assets/NcAppNavigationToggle-De8wq0JA.css';
import r from "../Components/NcButton.mjs";
import { r as s, x as o, a as l } from "./_l10n-BZu8wI2q.mjs";
import { n as i } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
s(o);
const c = {
  name: "MenuIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var p = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon menu-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, u = [], _ = /* @__PURE__ */ i(
  c,
  p,
  u,
  !1,
  null,
  null,
  null,
  null
);
const m = _.exports, f = {
  name: "MenuOpenIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var g = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon menu-open-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(n) {
    return t.$emit("click", n);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M21,15.61L19.59,17L14.58,12L19.59,7L21,8.39L17.44,12L21,15.61M3,6H16V8H3V6M3,13V11H13V13H3M3,18V16H16V18H3Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, d = [], v = /* @__PURE__ */ i(
  f,
  g,
  d,
  !1,
  null,
  null,
  null,
  null
);
const h = v.exports, C = {
  name: "NcAppNavigationToggle",
  components: {
    NcButton: r,
    MenuIcon: m,
    MenuOpenIcon: h
  },
  props: {
    /**
     * Tracks whether the toggle has been clicked or not.
     * If it has been clicked, switches between the different MenuIcons
     * and emits a boolean indicating its opened status
     */
    open: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["update:open"],
  computed: {
    label() {
      return this.open ? l("Close navigation") : l("Open navigation");
    }
  },
  methods: {
    /**
     * Once the toggle has been clicked, emits the toggle status
     * so parent components can gauge the status of the navigation button
     */
    toggleNavigation() {
      this.$emit("update:open", !this.open);
    }
  }
};
var M = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "app-navigation-toggle-wrapper" }, [e("NcButton", { staticClass: "app-navigation-toggle", attrs: { type: "tertiary", "aria-expanded": t.open ? "true" : "false", "aria-label": t.label, title: t.label, "aria-controls": "app-navigation-vue" }, on: { click: t.toggleNavigation }, scopedSlots: t._u([{ key: "icon", fn: function() {
    return [t.open ? e("MenuOpenIcon", { attrs: { size: 20 } }) : e("MenuIcon", { attrs: { size: 20 } })];
  }, proxy: !0 }]) })], 1);
}, $ = [], H = /* @__PURE__ */ i(
  C,
  M,
  $,
  !1,
  null,
  "e1dc2b3e",
  null,
  null
);
const N = H.exports;
export {
  N
};
